import React, { useState } from "react";
import { Card, Form, Button, Row, Col, Table, Alert } from "react-bootstrap";
import API from "../services/api";

const GuardVehicleLogs = () => {
  const [filters, setFilters] = useState({
    vehicleNumber: "",
    vendorName: "",
    from: "",
    to: "",
  });
  const [logs, setLogs] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchLogs = async () => {
    setLoading(true);
    setMessage("");
    try {
      const res = await API.get("/guard/vehicle-logs", { params: filters });
      setLogs(res.data || []);
      if (!res.data?.length) setMessage("No logs found for the filters.");
    } catch (err) {
      setMessage(err.response?.data?.message || "Failed to fetch logs.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Card className="shadow-sm mb-3">
        <Card.Body>
          <Card.Title>Gate Logs</Card.Title>
          <Row className="g-2">
            <Col md={3}>
              <Form.Label>Vehicle Number</Form.Label>
              <Form.Control
                type="text"
                value={filters.vehicleNumber}
                onChange={(e) =>
                  setFilters({ ...filters, vehicleNumber: e.target.value.toUpperCase() })
                }
                placeholder="UP14AB1234"
              />
            </Col>
            <Col md={3}>
              <Form.Label>Vendor Name</Form.Label>
              <Form.Control
                type="text"
                value={filters.vendorName}
                onChange={(e) => setFilters({ ...filters, vendorName: e.target.value })}
                placeholder="Vendor"
              />
            </Col>
            <Col md={2}>
              <Form.Label>From</Form.Label>
              <Form.Control
                type="date"
                value={filters.from}
                onChange={(e) => setFilters({ ...filters, from: e.target.value })}
              />
            </Col>
            <Col md={2}>
              <Form.Label>To</Form.Label>
              <Form.Control
                type="date"
                value={filters.to}
                onChange={(e) => setFilters({ ...filters, to: e.target.value })}
              />
            </Col>
            <Col md={2} className="d-flex align-items-end">
              <Button variant="success" className="w-100" onClick={fetchLogs} disabled={loading}>
                Search
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {message && <Alert variant="info">{message}</Alert>}

      <Card className="shadow-sm">
        <Card.Body>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Vehicle</th>
                <th>Vendor</th>
                <th>Type</th>
                <th>Qty</th>
                <th>Time In</th>
                <th>Time Out</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <tr key={log._id}>
                  <td>{log.vehicleNumber}</td>
                  <td>{log.vendorName}</td>
                  <td>{log.materialType}</td>
                  <td>
                    {log.actualQuantity || 0} {log.unit || ""}
                  </td>
                  <td>{log.timeIn ? new Date(log.timeIn).toLocaleString() : "--"}</td>
                  <td>{log.timeOut ? new Date(log.timeOut).toLocaleString() : "--"}</td>
                  <td>{log.status}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </div>
  );
};

export default GuardVehicleLogs;
